/* global BS */
const { DOM } = BS

const classPrefix = 'js-pe-'
const contentGroupClass = `${classPrefix}content-group`
const indexGroupClass = `${classPrefix}index-group`
const indexActiveClass = `${classPrefix}index-active`
const hideClass = 'hide'

BS.DOMReady(() => {
	const contentE = DOM.q('.' + contentGroupClass)
	const indexE = DOM.q('.' + indexGroupClass)
	const useIndexInput = DOM.q('[name*="[use_index]"]')
	if (!contentE || !indexE || !useIndexInput) return

	const update = () => {
		const { checked } = useIndexInput
		contentE.classList[checked ? 'add' : 'remove'](indexActiveClass)
		indexE.classList[checked ? 'remove' : 'add'](hideClass)
	}

	useIndexInput.addEventListener('change', update)
	update()
})
